export const USER_FLOW_CONSTANTS = {
  selectLocation: 'Select Location',
};
